import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Skeleton } from 'components/Skeleton';
import FSTable from '../ReactBootstrapTable';
import { TableHeaderColumn } from 'react-bootstrap-table';
import Form from '../../components/react-validation/components/form';
import { Dropdown } from '../Dropdown/Dropdown';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import * as WorkOrderActionType from '../../Work-Orders/constants';
import * as ProjectActionType from '../../Projects/constants';
import * as LotActionType from '../../Lots/constants';
import * as WOTActionType from '../../Work-Order-Type/constants';
import * as TradeActionType from '../../Trades/constants';
import * as ItemActionType from '../../Items/constants';
import * as SubcontractorActionType from '../../Subcontractors/constants';
import Moment from 'moment';
import * as PunchListActionType from '../../Punch-List/constants';
import shallowEqual from 'recompose/shallowEqual'
import {Modal} from 'react-bootstrap'
import { Popup } from '../Popup/popup';
import Dropzone from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';
import Input from 'components/react-validation/components/input';
import Datetime from 'react-datetime';
import { AppSettings } from '../../constants';
import ResolvePopup from '../../Work-Orders/Components/ResolvePopup';
import SignoffPopup from '../../Work-Orders/Components/SignoffPopup';
import DeclinePopup from '../../Work-Orders/Components/DeclinePopup';
import ReopenPopup from '../../Work-Orders/Components/ReopenPopup';
import CloseReopenPopup from '../../Work-Orders/Components/CloseReopenPopup';
import PendingOpenPopup from '../../Work-Orders/Components/PendingOpenPopup';
import { toggleScrollBody } from 'helper/unit-helper';
import PubSub from "../../services/pubsub-service";
import ImageConvertor from "../../utils/ImageConvertor";
import * as PubSubActionType from "../../services/constants";
import word from '../../assets/img/file_word.png';
import excel from '../../assets/img/file_excel.png';
import pdf from '../../assets/img/file_pdf.png';
import ppt from '../../assets/img/file_pp.png';
import video from '../../assets/img/file_video.png';
import other from '../../assets/img/file_other.png';
import { OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
// import { ContextMenu } from '../context-menu/context-menu';

var yesterday = Moment().subtract( 1, 'day' );
var isValidAppointmentDate = function( current ){
    return current.isAfter( yesterday );
};

const MAXIMUM_FILE_SIZE = 1024 * 1024 * 10; //10MB

let isDisabled = true;
let originalState = null;
let woValueChange = false;
let commentAdded = false ;
let isUpdateSend = true; 
class TableList extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    WorkOrderProfile: PropTypes.object,
    rfsInformation: PropTypes.object,
    WorkOrderTypeList: PropTypes.any,
    TradeList: PropTypes.any,
    ItemToRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    LotList: PropTypes.any,
    UserList: PropTypes.any,
    rfsId: PropTypes.string,
    workOrderId: PropTypes.string,
    onCancelClick: PropTypes.func,
    UserProfile: PropTypes.object,
    isPunchItem: PropTypes.bool,
    fetchWorkOrdersList: PropTypes.func,
    fetchDetailRfs: PropTypes.func,
    openAccordion: PropTypes.any,
    LotStore: PropTypes.object,
    UploadSuccess: PropTypes.bool,
    checkHomeownerWO: PropTypes.string,
    WorkOrderCredentials: PropTypes.any,
    renderIconAccordion: PropTypes.func,
    // WorkOrderCommentList: PropTypes.any,
    LastResolvedByDetails: PropTypes.any
  }

  constructor(props) {
    super(props);
    this.woInformation = {} ;
    this.state = {
      WorkOrderCommentList:[],
      defaultSortName: props.options.defaultSortName, // default sort column name
      defaultSortOrder: props.options.defaultSortOrder, // default sort order,
      currentPage: props.options.currentPage || 1,
      data: props.data,
      totalDataSize: props.options.totalDataSize,
      sizePerPage: props.options.sizePerPage,
      totalRecord: props.options.totalRecord,
      selected: [],   
      SelectedWO: null,
      assignedUser: '',
      isLoadingLocation: false,
      isLoadingTrade: false,
      isLoadingSubcontractor: false,
      isLoadingUser: false,
      isLoadingItemToRepair: false,
      isLoadingProblem: false,
      isLoadingWorkOrderType: false,
      isInitialUser: false,  
      title: null,
      description: null,
      appointmentDate: null,
      trade: null,
      itemToRepair: null,
      subcontractor: null,
      workOrderType: null,
      problem: null,
      isAttachment: true,
      user: null,
      isModeAssignSub: true,
      description_note: '',
      comment_note: '',
      displayModal:false,
      modalContent:'',
      heading: '',
      files: [],
      listImages: [],
      errorFile: null,
      conditionRenderBottomBtn: null,
      popup: {
        isShowOpenPopup: false,
        isShowPendPopup: false,
        isShowResolvePopup: false,
        isShowSignoffPopup: false,
        isShowDeclinePopup: false,
        isShowOpenPendingPopup: false,
        isShowReopenPopup: false,
        iShowCloseReopenPopup: false,
        iShowClosePendingPopup: false,
        isShowPendingOpenPopup: false
      },
      isReview: true,
      isEditResolved: false,
      isEditClosed: false,
      isEditReOpen: false,
      isEditAppointment: false,
      cancelUploadList: {},
      deleteUploadList: {},
    };
    isDisabled = true;
    woValueChange = false;
    commentAdded = false ;
    isUpdateSend = true;

    this.onTogglePopup = this.onTogglePopup.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { data, options } = nextProps;
    if (data) {
      this.setState({
        data: data,
        defaultSortName: options.defaultSortName,
        defaultSortOrder: options.defaultSortOrder,
        totalDataSize: options.totalDataSize,
        sizePerPage: options.sizePerPage,
        totalRecord: options.totalRecord,
        currentPage: options.currentPage //eslint-disable-line
          ? options.currentPage //eslint-disable-line
          : options.totalRecord === this.state.totalRecord || //eslint-disable-line
            this.state.totalRecord === 0 //eslint-disable-line
          ? this.state.currentPage //eslint-disable-line
          : 1 //eslint-disable-line
      });
    }   
    if (nextProps.TradeList) {this.setState({isLoadingTrade: false});}
    if (nextProps.SubcontractorList) {this.setState({isLoadingSubcontractor: false});}
    if (nextProps.UserList) {this.setState({isLoadingUser: false});}
    if (nextProps.ItemToRepairList) {this.setState({isLoadingItemToRepair: false});}
    if (nextProps.ProblemList) {this.setState({isLoadingProblem: false});}
    if (nextProps.WorkOrderTypeList) {this.setState({isLoadingWorkOrderType: false});}
  }

  componentWillUpdate(nextProps, nextState) {    
    if (nextState && originalState) {
      const checkCommentChanged=(
        !shallowEqual(nextState.description_note, originalState.description_note) ||
        !shallowEqual(nextState.comment_note, originalState.comment_note)
      );

      const checkStateChanged = (
        !shallowEqual(nextState.workOrderType, originalState.workOrderType) ||
        !shallowEqual(nextState.trade, originalState.trade) ||
        !shallowEqual(nextState.itemToRepair, originalState.itemToRepair) ||
        !shallowEqual(nextState.problem, originalState.problem) ||
        !shallowEqual(nextState.room, originalState.room) ||
        !shallowEqual(nextState.subcontractor, originalState.subcontractor) ||
        (nextState.user && !originalState.user) ||
        (!nextState.user && originalState.user) ||
        (nextState.user && originalState.user && nextState.user.value !== originalState.user.value) ||
        (nextState.title !== originalState.title) ||
        (nextState.description !== originalState.description) ||
        Moment(nextState.appointmentDate).format('MM/DD/YYYY hh/mm A') !==
        Moment(originalState.appointmentDate).format('MM/DD/YYYY hh/mm A')      
        );

        if(this.props.openAccordion == true && nextState.SelectedWO !== null){
          if(nextState.workOrderType && nextState.trade && nextState.itemToRepair && nextState.problem){
            if(nextState.subcontractor || nextState.user){
              isUpdateSend = false
            }else{
              isUpdateSend = true
            }
          }else{
            isUpdateSend = true
          }
        }

        if (checkStateChanged || checkCommentChanged) {          
          isDisabled = false;

          if(checkStateChanged && !checkCommentChanged){
            woValueChange = true 
            commentAdded = false
          }else if(checkCommentChanged && !checkStateChanged){
            woValueChange = false 
            commentAdded = true
          }else{
            woValueChange = true 
            commentAdded = true
          }
        } else {
        //   if(nextState.attachmentFiles.length > 0){
        //     isDisabled = false;
        //   }else{
            isDisabled = true;
        //   }
        }
    }
  }
  
  // onResetPageNumber = () => {
  //   this.setState({ currentPage: 1 });
  // }

  toolTip(type) {
    return (
      <Tooltip className='in tooltip-siteone'>
        {type === 'open' && <span>Send this work order to the assignee</span>
        // <span>Opening a work order will also send it to the specified subcontractor.</span>
        }
        {type === 'pend' && (
          // <span>Pending a work order will not send it to the specified subcontractor (if any)</span>
          <span>
            Pending a work order will not send it to the assignee (if any)
          </span>
        )}
      </Tooltip>
    );
  }

  handleChange = (event) => {
    this.setState({
      ...this.state,
      [event.target.name]: event.target.value,
    });
  };

  isAdmin = () => {
    return this.roleName === AppSettings.SYSTEM_ADMINISTRATOR || this.roleName === AppSettings.BUILDER_ADMIN || this.roleName === AppSettings.BUILDER_SUPER_ADMIN;
  }

  onToggleReopenPopup = () => {
    toggleScrollBody(this.state.popup.isShowReopenPopup);

    this.setState({
      popup: {
        isShowReopenPopup: !this.state.popup.isShowReopenPopup
      }
    });
  };

  onGetBuilderProfileReOpen = reopenReason => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: this.props.workOrderProfile.requestDetail.lot.id
      },
      callbackGetBuilderProfile: builderProfile => {
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA,
          params: {
              RefNo:  woInformation.rfsRefNo,
              WorkOrderRefNo: woInformation.refNo,
              Status: '6',
          }});
        this.onReopenHomeownerWorkOrder(builderProfile, reopenReason);
      }
    });
  };

  onSaveReopenPopup = (isFromResolved, reopenReason, woInformation) => {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileReOpen(reopenReason);
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          item =>
            item.lot.id === this.props.workOrderProfile.requestDetail.lot.id
        );
        if (lotFound) {
          this.onReopenHomeownerWorkOrder(
            lotFound.builderProfile,
            reopenReason
          );
        } else {
          this.onGetBuilderProfileReOpen(reopenReason);
        }
      }
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.RE_OPEN_WORK_ORDER_ASYNC,
        params: {
          refNo: woInformation.refNo,
          rfsId: woInformation.rfsRefNo,
          isFromResolved: isFromResolved,
          data: {
            status: 'Reopen',
            reopenReason: reopenReason
          }
        },
        callback:()=>{
          this.props.dispatch({
            type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA,
            params: {
                RefNo:  woInformation.rfsRefNo,
                WorkOrderRefNo: woInformation.refNo,
                Status: '6',
            }});
          if(this.props.fetchWorkOrdersList){
            this.props.fetchWorkOrdersList();
          }else if(this.props.fetchDetailRfs){
            this.props.fetchDetailRfs();
          }
        },
      });
    }
    this.onToggleReopenPopup();
    this.onhandleClose(woInformation.refNo)
  };

  onSortChange(sortName) {
    let order = '';
    if (sortName !== this.state.defaultSortName) {
      order = 'descending';
    } else {
      order =
        this.state.defaultSortOrder === 'ascending'
          ? 'descending'
          : 'ascending';
    }
    const params = {
      defaultSortName: sortName,
      defaultSortOrder: order,
      sizePerPage: this.props.options.sizePerPage,
      currentPage: 1
    };

    this.setState(
      {
        defaultSortName: sortName,
        defaultSortOrder: order,
        sizePerPage: this.props.options.sizePerPage,
        currentPage: 1
      },
      () => {
        if (this.props.refreshList) {
          this.props.refreshList(params);
        }
      }
    );
  }

  fetchDetailWorkOrder = (selected) => {
    const {data} = this.state
    const SelectedWO = data.find((item)=> item.refNo == selected)

      this.props.dispatch({
        type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_ASYNC,
        params: {
          rfsRefNo: SelectedWO.rfsRefNo ? SelectedWO.rfsRefNo :'',
          woRefNo: SelectedWO.refNo ? SelectedWO.refNo : ''
        },
        callback:(data)=>{
          this.woInformation = this.props.WorkOrderProfile && this.props.WorkOrderProfile.workOrder && this.props.WorkOrderProfile.workOrder.woInformation ? this.props.WorkOrderProfile.workOrder.woInformation : {} ;
          this.prefillData(this.woInformation );
          const params = {
            take: 10,
            skip: -1,
          };
          this.props.dispatch({
            type: WorkOrderActionType.GET_WORK_ORDER_COMMENTS_ASYNC,
            params: {
              workOrderId: SelectedWO.refNo,
              rfsId:SelectedWO.rfsRefNo,
              data: params,
            },
            callback:(data)=>{
            this.setState({WorkOrderCommentList:data})
            }
          });
          setTimeout(() => {
            this.props.dispatch({
            type: WorkOrderActionType.GET_LAST_RESOLVED_WORK_ORDER,
            params: {
              WOID: SelectedWO.refNo,
            },
        })
        }, 3000);
        },
        error:(apiResponse)=>{
         var errorStr = `Not found workOrderId: ${this.state.workOrderId}`
          if(apiResponse == errorStr) {
            this.props.dispatch({
              type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_ASYNC,
              params: {
                rfsRefNo: this.state.SelectedWO.rfsRefNo,
                woRefNo: this.state.SelectedWO.refNo,
              }});
          }
        }
      });
  };

  prefillData=(woInformation)=>{
    this.setState({
      title: woInformation.title,
      description: woInformation.description,
      appointmentDate: woInformation.appointmentDate?Moment(woInformation.appointmentDate):null,
      room: woInformation.room ? {
        value: woInformation.room.id,
        text: woInformation.room.name,
        extensionValue: null,
        selected: false
      } : null,
      trade: woInformation.trade ? {
        value: woInformation.trade.id,
        text: woInformation.trade.name,
        extensionValue: null,
        selected: false
      } : null,
      itemToRepair: woInformation.itemToRepair ? {
        value: woInformation.itemToRepair.id,
        text: woInformation.itemToRepair.description,
        extensionValue: null,
        selected: false
      } : null,
      subcontractor: woInformation.subcontractorProfile ? {
        value: woInformation.subcontractorProfile.subcontractorId,
        text: woInformation.subcontractorProfile.companyName,
        extensionValue: null,
        selected: false
      } : null,
      workOrderType: woInformation.workOrderType ? {
        value: woInformation.workOrderType.id,
        text: woInformation.workOrderType.name,
        extensionValue: null,
        selected: false
      } : null,
      problem: woInformation.problem ? {
        value: woInformation.problem.id,
        text: woInformation.problem.name,
        extensionValue: null,
        selected: false
      } : null,
      user: woInformation.assignedUser ? {
        value: woInformation.assignedUser.id,
        text: `${woInformation.assignedUser.displayName}`,
        extensionValue: {email: woInformation.assignedUser.email},
        selected: false
      } : null,
      isModeAssignSub: woInformation.assignedUser ? false : true,
      isEditAppointment: this.woInformation.status == 6 ? true : false,
      conditionRenderBottomBtn: AppSettings.clientTypeValue === 'Homeowner' &&
      woInformation.status !== 0 &&
      woInformation.status !== 3 &&
      woInformation.status !== 4
    })
    originalState = this.state;
  }

  getSelectOptions = (isFetched, currentOption, dataSource) => {
    if (isFetched) {
      //check is trade inactive
      if (currentOption) {
        const optionFound = dataSource.find(item => item.value === currentOption.value);
        if (!optionFound) {
          //current trade is inactive
          return [...dataSource, {...currentOption, except: true}];
        }
        return dataSource;
      }
      return dataSource;
    }
    return [{...currentOption}];
  }

    onChangeAppointmentDate = (appointmentDate) => {
    if (appointmentDate) {
      let currentDate = Moment(new Date());
      let currSelectedDate = Moment(appointmentDate._d);
      if(currentDate<=currSelectedDate){
      if (Moment(appointmentDate, "MM/DD/YYYY hh:mm A", true).isValid()) {
       this.setState({
          appointmentDate,
          error: null,
        });
      } 
      else {
        this.setState({
          error: "Invalid datetime.",
        });
      }
    } else {
      var selectedTime=Moment(appointmentDate._d,'MM/DD/YYYY hh:mm A').format('hh:mm A');
      this.setState({
        appointmentDate:Moment(appointmentDate._d,'MM/DD/YYYY hh:mm A').set({hour:Moment(selectedTime,'HH:mm').hour(), minute:Moment(selectedTime,'HH:mm').minute()}),
        error: null,
      });
    }
    } else {
      this.setState({
        appointmentDate,
        error: null,
      });
    }
  };

  fetchWOT = () => {
    this.setState({isLoadingWorkOrderType: true});
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      },
      callback: () => {
        this.setState({isFetchedWorkOrderType: true});
      }
    });
  }

  fetchSubcontractor = (trade) => {
    if (trade) {
      if (trade.id || trade.value) {
        this.setState({isLoadingSubcontractor: true});
        this.props.dispatch({
          type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
          params: {
            projectId: this.props.WorkOrderProfile.requestDetail.project.id,
            lotId: this.props.WorkOrderProfile.requestDetail.lot.id,
            tradeId: trade.id ? trade.id : trade.value,
            param: {
              searchKey: '',
              selectedValue: ''
            }
          },
          callback: () => {
            this.setState({isFetchedSubcontractor: true});
          }
        });
      }
    }
  }

  fetchUser = () => {
    this.setState({isLoadingUser: true});
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_USER_ASYNC,
      params: {
        projectId: this.props.WorkOrderProfile.requestDetail.project.id
      },
      callback: () => {
        this.setState({isFetchedUser: true});
      }
    });
  }

  fetchProblem = (itemToRepair) => {
    if (itemToRepair) {
      if (itemToRepair.id || itemToRepair.value) {
        this.setState({isLoadingProblem: true});
        this.props.dispatch({
          type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
          params: {
            id: itemToRepair.id ? itemToRepair.id : itemToRepair.value,
            searchKey: ''
          },
          callback: () => {
            this.setState({isFetchedProblem: true});
          }
        });
      }
    }
  }

  fetchItemRepair = (trade) => {
    if (trade) {
      if (trade.id || trade.value) {
        this.setState({isLoadingItemToRepair: true});
        this.props.dispatch({
          type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
          params: {
            id: trade.id ? trade.id : trade.value,
            searchKey: '',
            selectedValue: '',
            setDefaultSelected: false
          },
          callback: () => {
            this.setState({isFetchedItemToRepair: true});
          }
        });
      }
    }
  }

  fetchTrade = () => {
    this.setState({isLoadingTrade: true});
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.WorkOrderProfile.requestDetail.lot.id,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      },
      callback: () => {
        this.setState({isFetchedTrade: true});
      }
    });
  }

  onToggleResolvePopup = () => {
    toggleScrollBody(this.state.popup.isShowResolvePopup);

    this.setState({
      popup: {
        isShowResolvePopup: !this.state.popup.isShowResolvePopup
      }
    },() => {
      this.onResetCheckUploadFile();
    });
  };

  onClickEditButtonSubcontractor = () => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    if (AppSettings.clientTypeValue === 'Subcontractor') {
      if (woInformation.status === 1) {
        this.setState({
          isEditAppointment: true
        });
      }
    }
  }

  onSaveResolvePopup = (lastResolvedDate, comment, homeownerSignature, woInformation) => {
    this.props.dispatch({
      type: WorkOrderActionType.RESOLVE_WORK_ORDER_ASYNC,
      params: {
        refNo: woInformation.refNo,
        data: {
          status: 'Resolved',
          lastResolvedDate: lastResolvedDate,
          homeownerSignature: homeownerSignature,
          WorkOrderComments: comment
        },
        rfsRefNo: woInformation.rfsRefNo
      },
      callback: () => {
        if (comment) {
          const commentAction = 4;
          this.onClickAddComment(comment, commentAction, woInformation);
        }
        this.onToggleResolvePopup();
        if(this.props.fetchWorkOrdersList){
          this.props.fetchWorkOrdersList();
        }else if(this.props.fetchDetailRfs){
          this.props.fetchDetailRfs();
        }
        setTimeout(() => {
          this.props.dispatch({
            type: WorkOrderActionType.GET_LAST_RESOLVED_WORK_ORDER,
            params: {
              WOID: woInformation.refNo,
            },
        })
        }, 3000);
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE,
          params: {
              RefNo:  woInformation.rfsRefNo,
              WorkOrderRefNo: woInformation.refNo,
              Status: '4',
          }});
        this.onhandleClose(woInformation.refNo)
      }
    });
  };

  onClickAddComment = (comment, commentAction, woInformation, isPrivateNote = false) => {
    // const { woInformation } = this.props.workOrderProfile.workOrder;
    let data = { comment, isPrivateNote };

    if (commentAction) {
      data['commentAction'] = commentAction;
    }

    this.props.dispatch({
      type: WorkOrderActionType.ADD_WORK_ORDER_COMMENTS_ASYNC,
      params: {
        workOrderId: woInformation.refNo,
        rfsId: woInformation.rfsRefNo,
        data,
      },
      callback: () => {
        const params = {
          take: 10,
          skip: -1,
        };
        this.props.dispatch({
          type: WorkOrderActionType.GET_WORK_ORDER_COMMENTS_ASYNC,
          params: {
            workOrderId: woInformation.refNo,
            rfsId:woInformation.rfsRefNo,
            data: params,
          },
        });
      },
    });
  };


  renderInternalUserDropdown = (userOptions) => {
    if (this.props.UserProfile.sso) {
      return <Dropdown
        onChange={ref => {this.onSelectChange(ref, 'user');}}
        filter={true}
        className='filestring-dropdown filter-dropdown'
        onRemote={this.fetchUser}
        options={userOptions.map(item => { return {...item, text: `${item.text} (${item.extensionValue ? item.extensionValue.email:''})`}; })}
        loading={this.state.isLoadingUser}
        optionLabel='text'
        value={this.state.user}
        showClear={true}
        groupLabels={[
          {
            label: 'System users',
            field: 'sso',
            condition: [true]
          },
          {
            label: 'Builder users',
            field: 'sso',
            condition: [false, null]
          }
        ]}
        name='user'
        placeholder='--Select a user'
        style={{ width: '100%' }} />;
    }
    return <Dropdown
      onChange={ref => { this.onSelectChange(ref, 'user'); }}
      filter={true}
      className='filestring-dropdown filter-dropdown'
      onRemote={this.fetchUser}
      options={userOptions.map(item => { return {...item, text: `${item.text} (${item.extensionValue ? item.extensionValue.email:''})`}; })}
      loading={this.state.isLoadingUser}
      optionLabel='text'
      value={this.state.user}
      showClear={true}
      name='user'
      placeholder='--Select a user'
      style={{ width: '100%' }} />;
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
    if (name === 'itemToRepair') {
      this.setState({
        problem: null
      });
    }
    if (name === 'trade') {
      this.setState({
        subcontractor: null,
        itemToRepair: null,
        problem: null
      });
    }
  }

  handleModeAssign = mode => {
    if (mode === 'sub') {
      this.setState({isModeAssignSub: true, user: originalState.user});
    } else {
      this.setState({
        isModeAssignSub: false
      }, () => {
        this.setState({ subcontractor: this.state.trade ? originalState.subcontractor : null });
      });
      if (!this.state.user) {
        this.setState({
          user: {
            value: this.props.WorkOrderProfile.requestDetail && 
            this.props.WorkOrderProfile.requestDetail.managedByUser && 
            this.props.WorkOrderProfile.requestDetail.managedByUser.id,
            text: this.props.WorkOrderProfile.requestDetail.managedByUser.displayName,
            extensionValue: {email: this.props.WorkOrderProfile.requestDetail.managedByUser.email},
            selected: false
          }
        });
      }
    }
  }

  onToggleOpenPendingPopup = (woInformation) => {
    const { workOrderType, subcontractor, user} = this.state;

    if (
      (woInformation.subcontractorProfile || woInformation.assignedUser) &&
      woInformation.workOrderType
    ) {
      const param = {
        subcontractorId: woInformation.subcontractorProfile ? woInformation.subcontractorProfile.subcontractorId: null,
        assignedUserId: woInformation.assignedUser ? woInformation.assignedUser.id: null,
        workOrderTypeId: woInformation.workOrderType.id
      };
      this.onSaveOpenPendingPopup(param, woInformation);
    } else {
      const param = {
        subcontractorId: subcontractor ? subcontractor.value : null,
        assignedUserId: user ? user.value : null,
        workOrderTypeId: workOrderType.value
      };
      this.onSaveOpenPendingPopup(param, woInformation);
    }
  };

  onToggleCloseReopenPopup = () => {
    toggleScrollBody(this.state.popup.isShowCloseReopenPopup);
    this.setState({
      popup: {
        isShowCloseReopenPopup: !this.state.popup.isShowCloseReopenPopup
      }
    });
  };

  onReviewReopenWorkOrder = (data, woInformation) => {
    this.props.dispatch({
      type: WorkOrderActionType.REVIEW_RE_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: woInformation.refNo,
        rfsId: woInformation.rfsRefNo,
        data: data
      },
      callback: () => {
        if(data.status == 'Open'){
          this.setState({ 
            displayModal: true,
            modalContent: 'Work order updated and sent successfully',
            heading: 'Work order updated and sent'
          })
        }else{
          this.setState({ 
            displayModal: true,
            modalContent: 'Work order closed successfully',
            heading: 'Work order closed'
          })
        }
      }
    });
  };

  onSaveOpenPendingPopup = (param, woInformation) => {    
    this.props.dispatch({
      type: WorkOrderActionType.OPEN_PENDING_WORK_ORDER_ASYNC,
      params: {
        refNo: woInformation.refNo,
        rfsId: woInformation.rfsRefNo,
        data: {
          status: 'Open',
          subcontractorId: param.subcontractorId,
          assignedUserId: param.assignedUserId,
          workOrderTypeId: param.workOrderTypeId
        }
      },callback: () => {
        this.setState({ 
          displayModal: true,
          modalContent: 'Work order updated and sent successfully',
          heading: 'Work order updated and sent'
        })
      }
    });
  };

  handleSubmitForReview = (workOrderProfile) => {
   const woInformation = workOrderProfile.workOrder.woInformation
 
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileSubmitReview();
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          item =>
            item.lot.id === workOrderProfile.requestDetail.lot.id
        );
        if (lotFound) {
          this.onSubmitReviewHomeownerWorkOrder(lotFound.builderProfile);
        } else {
          this.onGetBuilderProfileSubmitReview();
        }
      }
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.SUBMIT_DECLINED_WORK_ORDER_ASYNC,
        params: {
          refNo: woInformation.refNo,
          rfsId: woInformation.rfsRefNo,
          data: {
            status: 0
          }
        },callback: () => {
          if(this.props.fetchWorkOrdersList){
            this.props.fetchWorkOrdersList();
          }else if(this.props.fetchDetailRfs){
            this.props.fetchDetailRfs();
          }
          this.onhandleClose(woInformation.refNo)
        }
      
      });
    }  
  };

  onCheckHomeownerSignatureWO = (woInformation) => {
    this.props.dispatch({
      type: WorkOrderActionType.CHECK_HOMEOWNER_SIGNATURE_WO_ASYNC,
      params: {
        refNo: woInformation.refNo
      }
    });
  }

  onGetBuilderProfileSubmitReview = () => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: this.props.workOrderProfile.requestDetail.lot.id
      },
      callbackGetBuilderProfile: builderProfile => {
        this.onSubmitReviewHomeownerWorkOrder(builderProfile);
      }
    });
  };

  onSubmitReviewHomeownerWorkOrder = builderProfile => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: WorkOrderActionType.SUBMIT_DECLINED_HOMEOWNER_WORK_ORDER_ASYNC,
      params: {
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        param: {
          refNo: woInformation.refNo,
          data: {
            status: 0
          }
        } 
      }
    });
  };

  onToggleDeclinePopup = () => {
    this.setState({
      popup: {
        isShowDeclinePopup: !this.state.popup.isShowDeclinePopup
      }
    });
  };

  onSaveDeclinePopup =(declineReason, workOrderProfile)=> {
    let projectID = workOrderProfile.requestDetail.project.id
    const refNo = workOrderProfile.workOrder.woInformation.refNo
    const rfsId = workOrderProfile.workOrder.woInformation.rfsRefNo

    this.props.dispatch({
      type: WorkOrderActionType.DECLINE_WORK_ORDER_ASYNC,
      params: {
        refNo: refNo,
        rfsId: rfsId,
        data: {
          status: 'Declined',
          declinedReason: declineReason,
        },
        projectId: projectID
      },callback: () => {
        if(this.props.fetchWorkOrdersList){
          this.props.fetchWorkOrdersList();
        }else if(this.props.fetchDetailRfs){
          this.props.fetchDetailRfs();
        }
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA,
          params: {
              RefNo: rfsId,
              WorkOrderRefNo: refNo,
              Status: '3',
          }});
      }
    });
    this.onToggleDeclinePopup();
    this.onhandleClose(refNo)
  };

  onTogglePopup = type => () => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const requireFormField = [];
    if (!woInformation.trade) {
      requireFormField.push('trade');
    }
    if (!woInformation.subcontractorProfile && !woInformation.assignedUser) {
      requireFormField.push('assigned');
    }
    if (!woInformation.itemToRepair) {
      requireFormField.push('itemRepair');
    }
    if (!woInformation.problem) {
      requireFormField.push('problem');
    }
    if (!woInformation.workOrderType) {
      requireFormField.push('workOrderType');
    }

    if (!requireFormField.length && type === 'open') {
      let params = {
        tradeId: woInformation.trade.id,
        itemToRepairId: woInformation.itemToRepair.id,
        subcontractorId: woInformation.subcontractorProfile
          ? woInformation.subcontractorProfile.subcontractorId
          : null,
        assignedUserId: woInformation.assignedUser
          ? woInformation.assignedUser.id
          : null,
        workOrderTypeId: woInformation.workOrderType
          ? woInformation.workOrderType.id
          : null,
        problemId: woInformation.problem.id,
        status: 'Open'
      };
      this.onClickSubmitOpenPend(type, params);
    } else if (
      (requireFormField.length === 1 &&
        requireFormField.includes('assigned') &&
        type === 'pend') ||
      (requireFormField.length === 1 &&
        requireFormField.includes('workOrderType') &&
        type === 'pend') ||
      (requireFormField.length === 2 &&
        requireFormField.includes('assigned') &&
        requireFormField.includes('workOrderType') &&
        type === 'pend') ||
      (!requireFormField.length && type === 'pend')
    ) {
      let params = {
        tradeId: woInformation.trade.id,
        itemToRepairId: woInformation.itemToRepair.id,
        subcontractorId: woInformation.subcontractorProfile
          ? woInformation.subcontractorProfile.subcontractorId
          : null,
        assignedUserId: woInformation.assignedUser
          ? woInformation.assignedUser.id
          : null,
        workOrderTypeId: woInformation.workOrderType
          ? woInformation.workOrderType.id
          : null,
        problemId: woInformation.problem.id,
        status: 'Pending'
      };
      this.onClickSubmitOpenPend(type, params);
    } else {
      switch (type) {
        case 'open': {
          this.setState({
            popup: {
              isShowOpenPopup: !this.state.popup.isShowOpenPopup
            },
            requireFormField
          });
          break;
        }
        case 'pend':
          this.setState({
            popup: {
              isShowPendPopup: !this.state.popup.isShowPendPopup
            },
            requireFormField
          });
          break;
        default:
          break;
      }
    }
  };

  onSaveResolveSubcontractorWOPopup = (lastResolvedDate, comment, homeownerSignature) => {
    const {
      workOrderProfile: { builderProfile }
    } = this.props;

    this.props.dispatch({
      type: WorkOrderActionType.RESOLVE_SUBCONTRACTOR_WORK_ORDER_ASYNC,
      params: {
        endpoint: builderProfile.resolveWOEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        data: {
          lastResolvedDate: lastResolvedDate,
          homeownerSignature: homeownerSignature
        }
      },
      callback: () => {
        if (comment) {
          const commentAction = 4;
          this.onClickAddComment(comment, commentAction);
        }
        this.onToggleResolvePopup();
        this.onhandleClose(refNo)
      }
    });
  };

  onToggleSignoffPopup = () => {
    console.log('Work commnets list ---', this.props.WorkOrderCommentList)
    toggleScrollBody(this.state.popup.isShowSignoffPopup);

    this.setState({
      popup: {
        isShowSignoffPopup: !this.state.popup.isShowSignoffPopup
      }
    },() => {
      this.onResetCheckUploadFile();
    });
  };

  signOffUploadFile = file => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileSignOffUploadFile(file);
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          item =>
            item.lot.id === this.props.workOrderProfile.requestDetail.lot.id
        );
        if (lotFound) {
          this.onSignOffHomeownerUploadFile(lotFound.builderProfile, file);
        } else {
          this.onGetBuilderProfileSignOffUploadFile(file);
        }
      }
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
        params: { resourcePath: `work-order/${woInformation.refNo}` },
        callback: () => {
          this.onSignOffUploadFile(file);
        }
      });
    }
  };

  onGetBuilderProfileSignOff = (lastResolvedDate, lastClosedDate, homeownerSignature) => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;

    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: this.props.workOrderProfile.requestDetail.lot.id
      },
      callbackGetBuilderProfile: builderProfile => {
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE,
          params: {
              RefNo:  woInformation.rfsRefNo,
              WorkOrderRefNo: woInformation.refNo,
              Status: '5',
          }});
        this.onSignOffHomeownerWorkOrder(
          builderProfile,
          lastResolvedDate,
          lastClosedDate,
          homeownerSignature
        );
      }
    });
  };

  onSaveSignoffPopup = (lastResolvedDate, lastClosedDate, homeownerSignature) => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const resolveDate = this.props.WorkOrderProfile.workOrder.woInformation.lastResolvedDate
    const lastResolveByName = this.props.LastResolvedByDetails !== undefined ? this.props.LastResolvedByDetails.actor
    :'';
    var signOffComment = ""
  
    this.state.WorkOrderCommentList && this.state.WorkOrderCommentList.items.map((createdDate) => {
      if(Moment(createdDate.createdDate).format('MM/DD/YYYY') == Moment(resolveDate).format('MM/DD/YYYY')){
        signOffComment = createdDate.comment
      }
    })
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileSignOff(lastResolvedDate, lastClosedDate, homeownerSignature, signOffComment, lastResolveByName);
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          item =>
            item.lot.id === this.props.workOrderProfile.requestDetail.lot.id
        );
        if (lotFound) {
          this.onSignOffHomeownerWorkOrder(
            lotFound.builderProfile,
            lastResolvedDate,
            lastClosedDate,
            homeownerSignature,
            signOffComment,
            lastResolveByName          
            );
        } else {
          this.onGetBuilderProfileSignOff(lastResolvedDate, lastClosedDate, homeownerSignature, signOffComment, lastResolveByName);
        }
      }
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.SIGN_OFF_WORK_ORDER_ASYNC,
        params: {
          refNo: woInformation.refNo,
          rfsId: woInformation.rfsRefNo,
          data: {
            status: 'Closed',
            lastResolvedDate: lastResolvedDate,
            lastClosedDate: lastClosedDate,
            homeownerSignature: homeownerSignature,
            WorkOrderComments: signOffComment,
            WorkOrderResolvedBy:lastResolveByName
          }
        }, callback: ()=>{
          this.props.dispatch({
            type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE,
            params: {
                RefNo:  woInformation.rfsRefNo,
                WorkOrderRefNo: woInformation.refNo,
                Status: '5',
            }});
          this.onToggleSignoffPopup();
          if(this.props.fetchWorkOrdersList){
            this.props.fetchWorkOrdersList();
          }else if(this.props.fetchDetailRfs){
            this.props.fetchDetailRfs();
          }
          this.onhandleClose(woInformation.refNo)
        }
      });
    }
    
  };

  onCheckUploadFile = () => {
    this.props.dispatch({
      type: WorkOrderActionType.UPLOAD_SIGNATURE_CHECK_STATUS
    });
  }
  onResetCheckUploadFile = () => {
    this.props.dispatch({
      type: WorkOrderActionType.UPLOAD_SIGNATURE_RESET_STATUS
    });
  }

  onTogglePendingOpenPopup = () => {
    toggleScrollBody(this.state.popup.isShowPendingOpenPopup);

    this.setState({
      popup: {
        isShowPendingOpenPopup: !this.state.popup.isShowPendingOpenPopup
      }
    });
  };

  onSavePendingOpenPopup = (holdReason, woInformation) => {
    const { isPunchItem } = this.props;
    const rfsId = woInformation.rfsRefNo

    this.props.dispatch({
      type: WorkOrderActionType.PENDING_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: woInformation.refNo,
        type: isPunchItem ? 'punchItem' : 'workOrder',
        rfsId,
        data: {
          holdReason
        }
      },
      callback: () => {
        this.onTogglePendingOpenPopup();
        if(this.props.fetchWorkOrdersList){
          this.props.fetchWorkOrdersList();
        }else if(this.props.fetchDetailRfs){
          this.props.fetchDetailRfs();
        }
      }
    });
    this.onhandleClose(woInformation.refNo)
  };

  onSavePendingSubcontractorOpenPopup = (holdReason, woInformation) => {
    this.onhandleClose(woInformation.refNo)
    const { workOrderProfile: { builderProfile }} = this.props;
    const rfsId = woInformation.rfsRefNo
    this.props.dispatch({
      type: WorkOrderActionType.PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_ASYNC,
      params: {
        endpoint: builderProfile.holdWOEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        data: {
          holdReason
        }
      },
      callback: () => {
        this.onTogglePendingOpenPopup();
        if (AppSettings.clientTypeValue === 'Builder') {
          this.props.history.push('/work-order-list');
        } else {
          this.props.history.push(`/punch-lists/${rfsId}`);
        }
      }
    });
  };

  onSendPunchItem = (woInformation) => {
    this.props.dispatch({
      type: PunchListActionType.SEND_PUNCH_ITEM_ASYNC,
      params: {
        punchListRefNo: woInformation.rfsRefNo,
        punchItemRefNo: woInformation.refNo,
        data: {
          subcontractorId: woInformation.subcontractorProfile
            ? woInformation.subcontractorProfile.subcontractorId
            : null,
          assignedUserId: woInformation.assignedUser
            ? woInformation.assignedUser.id
            : null,
          status: 'Open'
        }
      }
    });
    this.onhandleClose(woInformation.refNo)
  };

  renderButtonGroup(workOrderProfile) {
    const woInformation = workOrderProfile.workOrder.woInformation

    if (AppSettings.clientTypeValue === 'Subcontractor') {
      if (workOrderProfile.workOrder.woInformation.status === 1 && !this.state.isEditAppointment && workOrderProfile.viewOnly === false) {
        return (
          <ul className='wo-detail-bottom-btn'>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                onClick={this.onToggleResolvePopup}
              >
                Resolve
              </button>
              {this.state.popup.isShowResolvePopup && (
                <ResolvePopup
                  onSaveResolvePopup={this.onSaveResolveSubcontractorWOPopup}
                  onCancelResolvePopup={this.onToggleResolvePopup}
                  WorkOrderProfile={workOrderProfile}
                  WorkOrderCredentials={this.props.WorkOrderCredentials}
                  rfsId={woInformation.rfsRefNo}
                  workOrderId={woInformation.refNo}
                  onCheckHomeownerSignatureWO={()=>this.onCheckHomeownerSignatureWO(woInformation)}
                  checkHomeownerWO={this.props.checkHomeownerWO}
                  onCheckUploadFile={this.onCheckUploadFile}
                  onResetCheckUploadFile={this.onResetCheckUploadFile}
                  UploadSuccess={this.props.UploadSuccess}
                />
              )}
            </li>
            <li>
              <button
                className='btn btn-primary btn-siteone btn-wo-decline'
                onClick={this.onTogglePendingOpenPopup}
              >
                Pending
              </button>
              {this.state.popup.isShowPendingOpenPopup && (
                <PendingOpenPopup
                  onSavePendingOpenPopup={(holdReason)=>this.onSavePendingSubcontractorOpenPopup(holdReason, woInformation)}
                  onCancelPendingOpenPopup={this.onTogglePendingOpenPopup}
                />
              )}
            </li>
          </ul>
        );
      }
      return null;
    }
    return (
      <div>
        {/* Status: Schedule - COMPLETE*/}
        {/* {workOrderProfile.workOrder.woInformation.status === 7 &&
          AppSettings.clientTypeValue === 'Builder' && (
            <ul className='wo-detail-bottom-btn'>
              <li>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-edit'
                  onClick={this.onClickEditButton}
                >
                  Edit
                </button>
              </li>
            </ul>
          )} */}

        {/* Status: Awaiting Review */}
        {workOrderProfile.workOrder.woInformation.status === 0 &&
          AppSettings.clientTypeValue !== 'Homeowner' && (
            <ul className='wo-detail-bottom-btn'>
              <li>
                <OverlayTrigger
                  placement='top'
                  overlay={this.toolTip('open')}
                  delayHide={10}
                  delayShow={500}
                >
                  <button
                    className='btn btn-primary btn-siteone'
                    disabled={isUpdateSend}
                    onClick={this.onUpdateandSend}
                  >
                    Send
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement='top'
                  overlay={this.toolTip('pend')}
                  delayHide={10}
                  delayShow={500}
                >
                  <button
                    className='btn btn-primary btn-siteone'
                    disabled={isUpdateSend}
                    onClick={()=>this.onClickSubmitPend(woInformation)}
                  >
                    Pending
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <button
                  className='btn btn-primary btn-siteone btn-wo-decline'
                  onClick={this.onToggleDeclinePopup}
                >
                  No further attention
                </button>
                {this.state.popup.isShowDeclinePopup && (
                  <DeclinePopup
                    onCancelDeclinePopup={this.onToggleDeclinePopup}
                    onSaveDeclinePopup={(declineReason)=>this.onSaveDeclinePopup(declineReason, workOrderProfile)}
                  />
                )}
              </li>
            </ul>
          )}

        {/* Status: Open */}
        {workOrderProfile.workOrder.woInformation.status === 1 && (
          <ul className='wo-detail-bottom-btn'>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                onClick={this.onToggleResolvePopup}
              >
                Resolve
              </button>
              {this.state.popup.isShowResolvePopup && (
                <ResolvePopup
                  isAccordion={true}
                  onSaveResolvePopup={(lastResolvedDate, comment, homeownerSignature,)=>this.onSaveResolvePopup(lastResolvedDate, comment, homeownerSignature, woInformation)}
                  onCancelResolvePopup={this.onToggleResolvePopup}
                  rfsId={woInformation.rfsRefNo}
                  workOrderId={woInformation.refNo}
                  onCheckHomeownerSignatureWO={()=>this.onCheckHomeownerSignatureWO(woInformation)}
                  checkHomeownerWO={this.props.checkHomeownerWO}
                  onCheckUploadFile={this.onCheckUploadFile}
                  onResetCheckUploadFile={this.onResetCheckUploadFile}
                  UploadSuccess={this.props.UploadSuccess}
                />

              )}
            </li>
            {(this.isAdmin() === true || this.isWOCloseBtnEnabled()) &&
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-close'
                onClick={this.onToggleSignoffPopup}
              >
                Close
              </button>
              {this.state.popup.isShowSignoffPopup && (
                <SignoffPopup
                  isAccordion={true}
                  workOrderId={woInformation.refNo}
                  isSignoffFromOpen={true}
                  onSaveSignoffPopup={this.onSaveSignoffPopup}
                  onCancelSignoffPopup={this.onToggleSignoffPopup}
                  rfsId={woInformation.rfsRefNo}
                  onCheckHomeownerSignatureWO={()=>this.onCheckHomeownerSignatureWO(woInformation)}
                  checkHomeownerWO={this.props.checkHomeownerWO}
                  onCheckUploadFile={this.onCheckUploadFile}
                  onResetCheckUploadFile={this.onResetCheckUploadFile}
                  UploadSuccess={this.props.UploadSuccess}
                />
              )}
            </li>
            }
            <li>
              <button
                className='btn btn-primary btn-siteone btn-wo-decline'
                onClick={this.onTogglePendingOpenPopup}
              >
                Pending
              </button>
              {this.state.popup.isShowPendingOpenPopup && (
                <PendingOpenPopup
                  onSavePendingOpenPopup={(holdReason)=>this.onSavePendingOpenPopup(holdReason, woInformation)}
                  onCancelPendingOpenPopup={this.onTogglePendingOpenPopup}
                />
              )}
            </li>
          </ul>
        )}

        {/* Status: Resolved (mode review) - COMPLETE */}
        {workOrderProfile.workOrder.woInformation.status === 4 &&
          !this.state.isEditResolved && (
            <ul className='wo-detail-bottom-btn'>
            {(this.isAdmin() === true || this.isWOCloseBtnEnabled()) &&
              <li>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-close'
                  onClick={this.onToggleSignoffPopup}
                >
                  {AppSettings.clientTypeValue === 'Homeowner'
                    ? 'Sign off'
                    : 'Close'}
                </button>
                {this.state.popup.isShowSignoffPopup && (
                  <SignoffPopup
                    isAccordion={true}
                    isSignoffFromOpen={false}
                    onSaveSignoffPopup={this.onSaveSignoffPopup}
                    onCancelSignoffPopup={this.onToggleSignoffPopup}
                    onUploadFileToS3={this.signOffUploadFile}
                    rfsId={woInformation.rfsRefNo}
                    workOrderId={woInformation.refNo}
                    onCheckHomeownerSignatureWO={()=>this.onCheckHomeownerSignatureWO(woInformation)}
                    checkHomeownerWO={this.props.checkHomeownerWO}
                    onCheckUploadFile={this.onCheckUploadFile}
                    onResetCheckUploadFile={this.onResetCheckUploadFile}
                    UploadSuccess={this.props.UploadSuccess}
                  />
                )}
              </li>
              }
              <li>
                {this.state.popup.isShowReopenPopup && (
                  <ReopenPopup
                    onSaveReopenPopup={data =>this.onSaveReopenPopup(true, data, woInformation)}
                    onCancelReopenPopup={this.onToggleReopenPopup}
                  />
                )}
                <button
                  className='btn btn-primary btn-siteone btn-wo-decline'
                  onClick={this.onToggleReopenPopup}
                >
                  Request to Re-open
                </button>
              </li>
            </ul>
          )}

        {/* Status: Closed - COMPLETE */}
        {workOrderProfile.workOrder.woInformation.status === 5 &&
          !this.state.isEditClosed && (
            <ul className='wo-detail-bottom-btn'>
              <li>
                {this.state.popup.isShowReopenPopup && (
                  <ReopenPopup
                    onSaveReopenPopup={data =>this.onSaveReopenPopup(false, data, woInformation)}
                    onCancelReopenPopup={this.onToggleReopenPopup}
                  />
                )}
                <button
                  className='btn btn-primary btn-siteone btn-wo-decline'
                  onClick={this.onToggleReopenPopup}
                >
                  Request to Re-open
                </button>
              </li>
            </ul>
          )}

        {/* Status: Declined - COMPLETE */}
        {workOrderProfile.workOrder.woInformation.status === 3 && (
          <ul className='wo-detail-bottom-btn'>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                onClick={()=>this.handleSubmitForReview(workOrderProfile)}
              >
                Submit for review
              </button>
            </li>
          </ul>
        )}

        {/* Status: Pending - COMPLETE */}
        {workOrderProfile.workOrder.woInformation.status === 2 && (
          <ul className='wo-detail-bottom-btn'>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                disabled={isUpdateSend}
                onClick={() => {
                  if (this.props.isPunchItem) {
                    this.onSendPunchItem(woInformation);
                  } else {
                    this.onToggleOpenPendingPopup(woInformation);
                  }
                }}
              >
                Send
              </button>
            </li>
          </ul>
        )}

        {/* Status: ReOpen - COMPLETE */}
        {workOrderProfile.workOrder.woInformation.status === 6 &&
          !this.state.isEditReOpen && (
            <ul className='wo-detail-bottom-btn'>
              <li>
                <button
                  className='btn btn-primary btn-siteone'
                  onClick={() =>
                    this.onReviewReopenWorkOrder({ status: 'Open' }, woInformation)
                  }
                >
                  Send
                </button>
              </li>
              <li>
                {this.state.popup.isShowCloseReopenPopup && (
                  <CloseReopenPopup
                    lastClosedDate={
                      workOrderProfile.workOrder.woInformation
                        .lastClosedDate
                    }
                    onSaveCloseReopenPopup={data =>
                      this.onReviewReopenWorkOrder(data, woInformation)
                    }
                    onCancelCloseReopenPopup={this.onToggleCloseReopenPopup}
                  />
                )}
            {(this.isAdmin() === true || this.isWOCloseBtnEnabled()) &&
              <button
                  className='btn btn-primary btn-siteone-default btn-wo-close'
                  onClick={this.onToggleCloseReopenPopup}
                >
                  Close
              </button>
            }
              </li>
            </ul>
          )}
      </div>
    );
  }

  onClickSubmitOpenPend = (params) => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    let rfsId = woInformation.rfsRefNo;
 
    this.props.dispatch({
      type: WorkOrderActionType.OPEN_AN_AWAITING_WORK_ORDER_ASYNC,
      params: {
        refNo: woInformation.refNo,
        rfsId,
        data: params
      },callback: () => {         
          this.setState({ 
            displayModal: true,
            modalContent: 'Work order updated and sent successfully',
            heading: 'Work order updated and sent'
          })
        }
    });
  };

  onClickSubmitPend = (woInformation) => {
    const { trade, workOrderType, subcontractor, itemToRepair, problem, user, isModeAssignSub} = this.state;
    let rfsId = woInformation.rfsRefNo;

    let params = {
      tradeId: trade ? trade.value : null,
      itemToRepairId: itemToRepair ? itemToRepair.value : null,
      subcontractorId: null,
      assignedUserId: null,
      workOrderTypeId: workOrderType ? workOrderType.value : null,
      problemId: problem ? problem.value : null,
      status: 'Pending'
    };

    if (isModeAssignSub) {
      params.subcontractorId = subcontractor ? subcontractor.value : null;
    } else {
      params.assignedUserId = user ? user.value : null;
    }

    this.props.dispatch({
      type: WorkOrderActionType.PEND_WORK_ORDER_ASYNC,
      params: {
        refNo: woInformation.refNo,
        rfsId,
        data: params
      }, callback:()=>{
        if(this.props.fetchWorkOrdersList){
          this.props.fetchWorkOrdersList();
        }else if(this.props.fetchDetailRfs){
          this.props.fetchDetailRfs();
        }
      }
    });
    this.onhandleClose(woInformation.refNo)
  };

  onUpdateandSend = () => {
    const { trade, workOrderType, subcontractor, itemToRepair, problem, user, isModeAssignSub} = this.state;

      let params = {
        tradeId: trade ? trade.value : null,
        itemToRepairId: itemToRepair ? itemToRepair.value : null,
        subcontractorId: null,
        assignedUserId: null,
        workOrderTypeId: workOrderType ? workOrderType.value : null,
        problemId: problem ? problem.value : null,
        status: 'Open'
      };

      if (isModeAssignSub) {
        params.subcontractorId = subcontractor ? subcontractor.value : null;
      } else {
        params.assignedUserId = user ? user.value : null;
      }

      this.onClickSubmitOpenPend(params);
      
  };

  handleClose () {
    this.setState({displayModal: false, isDisplayPopoverReassign : false})
  } 
  
  // CODE FOR ADDING COMMENT AND PRIVATE NOTE IN ACCORDION FEATURE FOR NOW IS COMMENTED
  // onClickAddNote = e => {
  //   this.setState({ loadingAddComment: true });
  //   const params = this.state.description_note;
  //   this.onClickAddComment(params, '', true);
  // };
  
  // onClickCommentNote = e => {
  //   this.setState({ loadingAddComment: true });
  //   const params = this.state.comment_note;
  //   this.onClickAddComment(params, '', false);
  // };

  // onClickAddComment = (comment, commentAction, isPrivateNote = false) => {
  //   let data = { comment, isPrivateNote };
  //   const { woInformation } = this.props.WorkOrderProfile.workOrder;
  //   if (commentAction) {
  //     data['commentAction'] = commentAction;
  //   }

  //   this.props.dispatch({
  //     type: WorkOrderActionType.ADD_WORK_ORDER_COMMENTS_ASYNC,
  //     params: {
  //       workOrderId: woInformation.refNo,
  //       rfsId: woInformation.rfsRefNo,
  //       data,
  //     }, callback: ()=>{
  //       this.setState({description_note: '', comment_note: ''})
  //     }
  //   });
  // };
  
// SUBMIT METHOD IF VALUES CHANGES AND COMMENT OR PRIVATE NOTE IS ADDED
  // onSubmit = (e) => {
  //   e.preventDefault();
  //   const {data} = this.state;
  //   const SelectedWO = data.find((item)=> item.refNo == this.state.selected)
  //   const { subcontractor, user, isModeAssignSub } = this.state;
  //   const { woInformation } = this.props.WorkOrderProfile.workOrder;

  //   if (this.state.files.length > 0 && woValueChange === false && commentAdded === false) {
  //     this.uploadAttachmentsToS3(this.state.files, woInformation);
  //   }else{
  //     if(woValueChange === true && commentAdded === false){

  //       if (woInformation.status === 1) {///status === Open
          
  //         let assignee = null;
  //         if (isModeAssignSub) {
  //           assignee = subcontractor ? subcontractor.value : null;
  //         } else {
  //           assignee = user ? user.value : null;
  //         }
  //         const showPopup = (
  //           (woInformation.assignedUser &&
  //           woInformation.assignedUser.id !== assignee) ||
  //           (woInformation.subcontractorProfile &&
  //             woInformation.subcontractorProfile.subcontractorId !== assignee)
  //         );
  //         if (showPopup) {
  //           //show popup
  //           this.setState({
  //             isDisplayPopoverReassign: true
  //           });
  //         } else {
  //           this.onSave(SelectedWO.refNo);
  //         }
  //       } else {
  //         this.onSave(SelectedWO.refNo);
  //       }
  //     }else if(commentAdded === true && woValueChange === false){ 
  //       if(this.state.comment_note !== '' && this.state.description_note !== ''){
  //         this.onClickCommentNote()
  //         this.onClickAddNote(SelectedWO.refNo)  
  //       }else if(this.state.comment_note !== ''){
  //         this.onClickCommentNote()
  //       }else{
  //         this.onClickAddNote(SelectedWO.refNo)  
  //       }

  //       if (this.state.files.length > 0) {
  //         this.uploadAttachmentsToS3(this.state.files, woInformation);
  //       }
  //     }else{
  //       if(this.state.comment_note !== '' && this.state.description_note !== ''){
  //         this.onClickCommentNote()
  //         this.onClickAddNote(SelectedWO.refNo)  
  //       }else if(this.state.comment_note !== ''){
  //         this.onClickCommentNote()
  //       }else{
  //         this.onClickAddNote(SelectedWO.refNo)  
  //       }

  //       if (woInformation.status === 1) {///status === Open
  //         let assignee = null;
  //         if (isModeAssignSub) {
  //           assignee = subcontractor ? subcontractor.value : null;
  //         } else {
  //           assignee = user ? user.value : null;
  //         }
  //         const showPopup = (
  //           (woInformation.assignedUser &&
  //           woInformation.assignedUser.id !== assignee) ||
  //           (woInformation.subcontractorProfile &&
  //             woInformation.subcontractorProfile.subcontractorId !== assignee)
  //         );
  //         if (showPopup) {
  //           //show popup
  //           this.setState({
  //             isDisplayPopoverReassign: true
  //           });
  //         } else {
  //           this.onSave(SelectedWO.refNo);
  //         }
  //       } else {
  //         this.onSave(SelectedWO.refNo);
  //       }
       
  //     }
  //   }
  // }

  onSubmit = (e) => {
    e.preventDefault();
    const {data} = this.state;
    const SelectedWO = data.find((item)=> item.refNo == this.state.selected)
    const { subcontractor, user, isModeAssignSub } = this.state;
    const { woInformation } = this.props.WorkOrderProfile.workOrder;

    if(woValueChange === true){
      if (woInformation.status === 1) {///status === Open
        let assignee = null;
        if (isModeAssignSub) {
          assignee = subcontractor ? subcontractor.value : null;
        } else {
          assignee = user ? user.value : null;
        }
        const showPopup = (
          (woInformation.assignedUser &&
          woInformation.assignedUser.id !== assignee) ||
          (woInformation.subcontractorProfile &&
            woInformation.subcontractorProfile.subcontractorId !== assignee)
        );
        if (showPopup) {
          //show popup
          this.setState({
            isDisplayPopoverReassign: true
          });
        } else {
          this.onSave(SelectedWO.refNo);
        }
      } else {
        this.onSave(SelectedWO.refNo);
      }
    }
  }

   onSave = (refNo) => {
    const { room, trade, workOrderType, subcontractor, itemToRepair, problem, appointmentDate, user, isModeAssignSub } = this.state;
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const { isPunchItem } = this.props;
    const { description, title } = this.form.getValues()
    let params = null;

    if (woInformation.status === 6) {
      params = {
        title: title,
        description,
        tradeId: trade ? trade.value : null,
        itemToRepairId: itemToRepair ? itemToRepair.value : null,
        subcontractorId: null,
        assignedUserId: null,
        problemId: problem ? problem.value : null
      };
    } else if (!isPunchItem || (isPunchItem && woInformation.status !== 2)) {
      params = {
        title: !isPunchItem ? title : woInformation.title,
        description,
        requestId: this.props.rfsId,
        tradeId: trade ? trade.value : null,
        roomId: room ? room.value : '' ,
        itemToRepairId: itemToRepair ? itemToRepair.value : null,
        subcontractorId: null,
        assignedUserId: null,
        workOrderTypeId: workOrderType ? workOrderType.value : null,
        problemId: problem ? problem.value : null,
        appointmentDate: Moment.isMoment(appointmentDate) ? Moment(appointmentDate).format() : appointmentDate,
        declinedReason: woInformation.declinedReason ? woInformation.declinedReason : null,
        lastClosedDate: woInformation.lastClosedDate ? woInformation.lastClosedDate : null,
        lastResolvedDate: woInformation.lastResolvedDate ? woInformation.lastResolvedDate : null
      };
    }
    else {
      params = { 
        title: woInformation.title,
        description,
        tradeId: trade ? trade.value : null,
        roomId: room ? room.value: null,
        itemToRepairId: itemToRepair ? itemToRepair.value : null,
        subcontractorId: null,
        assignedUserId: null,
        problemId: problem ? problem.value : null,
        appointmentDate: Moment.isMoment(appointmentDate) ? Moment(appointmentDate).format() : appointmentDate,
        declinedReason: woInformation.declinedReason ? woInformation.declinedReason : null,
        lastClosedDate: woInformation.lastClosedDate ? woInformation.lastClosedDate : null,
        lastResolvedDate: woInformation.lastResolvedDate ? woInformation.lastResolvedDate : null,
        reopenReason: woInformation.reopenReason ? woInformation.reopenReason : null
      };
    }

    if (isModeAssignSub) {
      params.subcontractorId = subcontractor ? subcontractor.value : null;
    } else {
      params.assignedUserId = user ? user.value : null;
    }
    if (woInformation.status === 6) {
      this.props.dispatch({
        type: WorkOrderActionType.EDIT_REQUESTED_RE_OPEN_WORK_ORDER_ASYNC,
        params: {
          refNo: woInformation.refNo,
          rfsId: woInformation.rfsRefNo,
          data: params
        },
        callback: () => {         
          // if (this.state.attachmentFiles.length > 0) {
          //   this.uploadAttachmentsToS3(this.state.attachmentFiles, woInformation);
          // }
          this.setState({ 
            displayModal: true,
            modalContent: 'Work order updated successfully',
            heading: 'Work order updated'
          })
        }
      });
    } else if (!isPunchItem || (isPunchItem && woInformation.status !== 2)) {
      this.props.dispatch({
        type: WorkOrderActionType.UPDATE_WORK_ORDER_ASYNC,
        params: {
          data: params,
          refNo: woInformation.refNo
        },
        callback: () => {    
          // if (this.state.attachmentFiles.length > 0) {
          //   this.uploadAttachmentsToS3(this.state.attachmentFiles, woInformation);
          // }      
          this.setState({ 
            displayModal: true,
            modalContent: 'Work order updated successfully',
            heading: 'Work order updated'
          })       
        }
      });
    } else {
      this.props.dispatch({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_ASYNC,
        params: {
          data: params,
          punchListRefNo: woInformation.rfsRefNo,
          punchItemRefNo: woInformation.refNo
        },
        callback: () => {
          // if (this.state.attachmentFiles.length > 0) {
          //   this.uploadAttachmentsToS3(this.state.attachmentFiles, woInformation);
          // }
          this.setState({ 
            displayModal: true,
            modalContent: 'Work order updated successfully',
            heading: 'Work order updated'
          })       
        }
      });
    }
    // this.onhandleClose(woInformation.refNo)
  }

  renderFileTypeIcon = (item) => {
    const extWord = ['doc', 'docx'];
    const extExcel = ['xls', 'xlsx'];
    const extPpt = ['ppt', 'pptx'];
    const extImage = ['jpg', 'jpeg', 'png', 'gif'];
    const extVideo = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
    const ext = item.name.split('.').pop().toLowerCase();
    if (extWord.includes(ext)) {return word;}
    else if (extExcel.includes(ext)) {return excel;}
    else if (extPpt.includes(ext)) {return ppt;}
    else if (extPpt.includes(ext)) {return ppt;}
    else if (extVideo.includes(ext)) {return video;}
    else if (ext === 'pdf') {return pdf;}
    else if (extImage.includes(ext)) {return item.preview ? item.preview : other;}
    else {return other;}
  }

  onDropOnAttachments = (e) => {
    // this.showLoading();
    let newFiles = this.state.files;
    let errorFile = null;
    try {
      e.map(async (file) => {
        const fileExtention = file.name.split(".").pop();
        if (fileExtention === "heif" || fileExtention === "heic") {
          /*HEIF or HEIC file convert to jpeg with package*/
          let convertedFile = await ImageConvertor.convertImage(file);
          let replaceFileName = `${file.name.split(".")[0]}.jpeg`;
          const blobToFile = new File([convertedFile], replaceFileName);
          if (blobToFile.size > MAXIMUM_FILE_SIZE) {
             //  this.hideLoading();
            errorFile = "File size must not exceed 10MB.";
            this.setState({errorFile: errorFile});
          } else {
            blobToFile["id"] = uuidv4();
            newFiles.push(blobToFile);

            this.setState(
              {
                files: newFiles,
                errorFile: ''
              },
              () => {
                this.uploadFileToS3(e);
              }
            );
          }
        } else {
          if (file.size > MAXIMUM_FILE_SIZE) {
            errorFile = "File size must not exceed 10MB.";
            this.setState({errorFile: errorFile});
          } else {
            file["id"] = uuidv4();
            newFiles.push(file);

            this.setState(
              {
                files: newFiles,
                errorFile: ''
              },
              () => {
                this.uploadFileToS3(e);
              }
            );
          }
        }
      });
      // this.hideLoading();
    } catch (e) {    
      // this.hideLoading();
    }
  };

  uploadFileToS3 = (e) => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;

    if (AppSettings.clientTypeValue === "Subcontractor") {
      const {
        WorkOrderProfile: { builderProfile },
      } = this.props;
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_SUBCONTRACTOR_AWS_S3_ASYNC,
        params: {
          data: {
            resourcePath: `work-order/${woInformation.refNo}`,
          },
          endpoint: builderProfile.s3SredentialsEndpoint,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken,
          },
        },
        callback: () => {
          this.state.files.map((file) => {
            this.props.dispatch({
              type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
              params: {
                refNo: woInformation.refNo,
                config: this.props.WorkOrderCredentials,
                file: file,
              },
              callback: this.onUploadFileCallback(file.name),
            });
          });
        },
      });
    } else if (AppSettings.clientTypeValue === "Builder") {
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
        params: { resourcePath: `work-order/${woInformation.refNo}` },
        callback: () => {    
          this.state.files.map((file) => {
            this.props.dispatch({
              type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
              params: {
                refNo: woInformation.refNo,
                config: this.props.WorkOrderCredentials,
                file: file,
              },
              callback: this.onUploadFileCallback(file.name),
            });
          });
        },
      });
    } else {
      const lotFound = this.props.LotStore.HomeownerLots.find(
        (item) =>
          item.lot.id === this.props.WorkOrderProfile.requestDetail.lot.id
      );
      const { builderProfile } = lotFound;
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_HOMEOWNER_AWS_S3_ASYNC,
        params: {
          data: {
            resourcePath: `work-order/${woInformation.refNo}`,
          },
          endpoint: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken,
          },
        },
        callback: (status, config) => {
          if (status) {
            this.state.files.map((file) => {
              this.props.dispatch({
                type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
                params: {
                  refNo: woInformation.refNo,
                  config,
                  file: file,
                },
                callback: this.onUploadFileCallback(file.name),
              });
            });
          }
        },
      });
    }
  };

  onUploadFileCallback = (fileName) => (status, data) => {
    // this.hideLoading()
    if (status === "pending") {
      const { cancelUploadList } = this.state;
      cancelUploadList[data.uploadId] = data.cancelUpload;
      this.setState({
        cancelUploadList,
      });
    } else if (status === "delete") {
      const { deleteUploadList } = this.state;
      deleteUploadList[data.uploadId] = data.deleteFile;
      this.setState({
        deleteUploadList,
      });
    } else {
      this.uploadAttachmentsToServer(data.data, fileName);
    }
  };

  uploadAttachmentsToServer = (data, fileName) => {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const rfsId = woInformation.rfsRefNo
    this.props.dispatch({
      type: WorkOrderActionType.UPLOAD_TO_SERVER_ASYNC,
      params: {
        refNo: woInformation.refNo,
        rfsId,
        data: {
          url: data.Location,
          key: data.Key,
          fileName: fileName,
        },
      }
    });
  };

  handleOnClick = () => {
    this.props.onCancelClick();
  }

  handleModalClose = (refNo) => {
    this.onhandleClose(refNo)
    this.setState({displayModal: false, isDisplayPopoverReassign: false})
    if(this.props.fetchWorkOrdersList){
      this.props.fetchWorkOrdersList();
    }else if(this.props.fetchDetailRfs){
      this.props.fetchDetailRfs();
    }

    // this.onhandleClose(refNo)
  }
  
  onhandleClose = refNo => {
    // this.setState({ selected: this.state.selected.filter(it => it !== refNo) });
    // return false;
    const checkID = this.state.selected.indexOf(refNo)
    if (checkID == -1) {
      // this.fetchDetailWorkOrder(refNo);
      this.setState({
        selected: [ refNo ],
        SelectedWO: this.state.data.find((item)=> item.refNo == refNo),
        trade: null,
        itemToRepair: null,
        subcontractor: null,
        workOrderType: null,
        problem: null,
        user: null,
        files: [],
        errorFile: null,
        appointmentDate: null,
        description: null,
        title: null,
      }); 
      originalState = null;
      isDisabled = true;
      isUpdateSend = true;
    } else {
      this.setState({ selected: this.state.selected.filter(it => it !== refNo) });
    }
    return false;
  }

  isExpandableRow = row =>{  
    const SelectedWO = this.state.data.find((item)=> item.refNo == this.state.selected) 
    if (SelectedWO == row) {
      return true
    }
    else {
      return false
    }
}  

  expandColumnComponent({ isExpandableRow, isExpanded }) {
    let content = '';
    if (isExpandableRow) {
      if(isExpanded == true){
        content = <i className="fa fa-minus-square-o" style={{fontSize:"20px", color: '#666'}} aria-hidden="true"></i>        
      }else{
        content = <i className="fa fa-minus-square-o" style={{fontSize:"20px", color: '#666'}} aria-hidden="true"></i>        
      }
    } else {
      content = <i className="fa fa-plus-square-o" style={{fontSize:"20px", color: '#666'}} aria-hidden="true"></i>;
    }
    return (
      <div> { content } </div>  
    );
  }  

  expandComponent = row => {
    const { data } = this.state;   
    
    if(this.state.selected.length !== 0){  

      const SelectedWO = data.find((item)=> item.refNo == this.state.selected) 
      let { title, description } = this.woInformation;
      if (this.form) {
        title = this.form.getValues(true).title;
        description = this.form.getValues(true).description;
      }

    const {
      isFetchedTrade, trade,
      isFetchedWorkOrderType, workOrderType,
      isFetchedRoom, room,
      isFetchedItemToRepair, itemToRepair,
      isFetchedProblem, problem,
      isFetchedSubcontractor, subcontractor,
      isFetchedUser, user, isEditAppointment
    } = this.state;

    const {
      TradeList,
      WorkOrderTypeList,
      RoomList,
      UserList,
      SubcontractorList,
      ItemToRepairList,
      ProblemList,
      isPunchItem
    } = this.props;

    const tradeOptions = this.getSelectOptions(isFetchedTrade, trade, TradeList);
    const workOrderTypeOptions = this.getSelectOptions(isFetchedWorkOrderType, workOrderType, WorkOrderTypeList);
    const locationOptions = this.getSelectOptions(isFetchedRoom, room, RoomList);
    const userOptions = this.getSelectOptions(isFetchedUser, user, UserList);
    const subcontractorOptions = this.getSelectOptions(isFetchedSubcontractor, subcontractor, SubcontractorList);
    const itemToRepairOptions = this.getSelectOptions(isFetchedItemToRepair, itemToRepair, ItemToRepairList);
    const problemOptions = this.getSelectOptions(isFetchedProblem, problem, ProblemList);
    const { woInformation } = this.props;

      return (
      <div className="row updateSeparateWO" style={{ marginLeft: 0, margin:'5px', background: 'white', paddingLeft: '35px', paddingRight: '15px' }} >      
        <Form ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
          <p style={{ marginTop: '10px' }}>{"To update a work order, you must specify the field(s) below"}</p>
        <div className='row col-lg-12 col-sm-12'>
            <div className=' col-sm-3' style={{paddingLeft: 0, marginRight: '15rem'}}>
              <label className='col-sm-12 control-label form-siteone-label'>Work order type </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
              <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'workOrderType'); }}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchWOT}
                  options={workOrderTypeOptions}
                  optionLabel='text'
                  value={this.state.workOrderType}
                  loading={this.state.isLoadingWorkOrderType}
                  showClear={true}
                  placeholder='Please select'
                  style={{ width: '100%' }} />
              </div>
            </div>

            <div className=' col-sm-3' style={{paddingLeft: 0, marginRight: '15rem'}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Trade
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
              <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'trade'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  options={tradeOptions}
                  optionLabel='text'
                  onRemote={this.fetchTrade}
                  value={this.state.trade}
                  loading={this.state.isLoadingTrade}
                  showClear={true}
                  placeholder='Please select'
                  style={{ width: '100%' }} />
              </div>
            </div>
            <div className=' col-sm-3' >
              <div className='col-sm-12 control-label form-siteone-label' style={{marginBottom: 5}}>
              <label
                className='col-sm-12 control-label form-siteone-label' style={{width: '100px'}}>
                 Assigned to 
              </label>
              <div
                  className="btn-group btn-group-sm wo-assign-btn-group"
                  role="group"
                >
                  <button
                  style={{
                    backgroundColor: this.state.isModeAssignSub
                      ? "#4267b2"
                      : "",
                    color: this.state.isModeAssignSub ? "#fff" : "",
                  }}
                  type="button"
                  className={
                    "btn btn-secondary " +
                    (this.state.isModeAssignSub ? "active hover" : "")
                  }
                  onClick={() => {
                    this.handleModeAssign("sub");
                  }}
                >
                  subcontractor
                </button>
                <button
                  style={{
                    backgroundColor: !this.state.isModeAssignSub
                      ? "#4267b2"
                      : "",
                    color: !this.state.isModeAssignSub ? "#fff" : "",
                  }}
                  type="button"
                  className={
                    "btn btn-secondary " +
                    (!this.state.isModeAssignSub ? "active hover" : "")
                  }
                  onClick={() => {
                    this.handleModeAssign("user");
                  }}
                >
                  internal user
                </button>
                </div>
              </div>
              <div className='col-sm-12' style={{paddingLeft: 15, paddingRight: 0}}>
                {this.state.isModeAssignSub
                  ? (
                    <Dropdown
                    onChange={ref => { this.onSelectChange(ref, 'subcontractor'); }}
                    filter={true}
                    className='filestring-dropdown filter-dropdown'
                    onRemote={() => {this.fetchSubcontractor(this.state.trade);}}
                    options={subcontractorOptions}
                    optionLabel='text'
                    value={this.state.subcontractor}
                    loading={this.state.isLoadingSubcontractor}
                    disabled={!this.state.trade}
                    showClear={true}
                    name='subcontractor'
                    placeholder='--Select a trade first'
                    style={{ width: '100%' }} />
                ) : (
                  this.renderInternalUserDropdown(userOptions)
                  )} 
              </div>
            </div> 
        </div>
        <div className='row col-lg-12 col-sm-12'>
            <div className=' col-sm-3' style={{paddingLeft: 0, marginRight: '15rem'}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Item to repair 
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
              <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'itemToRepair'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  options={itemToRepairOptions}
                  optionLabel='text'
                  disabled={!this.state.trade}
                  onRemote={() => {this.fetchItemRepair(this.state.trade);}}
                  value={this.state.itemToRepair}
                  loading={this.state.isLoadingItemToRepair}
                  showClear={true}
                  placeholder='Select a trade first'
                  style={{ width: '100%' }} />
              </div>
            </div>  
            <div className=' col-sm-3' style={{paddingLeft: 0, marginRight: '15rem'}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Problem 
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'problem'); }}
                  className='filestring-dropdown filter-dropdown'
                  options={problemOptions}
                  optionLabel='text'
                  disabled={!this.state.itemToRepair}
                  onRemote={() => {this.fetchProblem(this.state.itemToRepair);}}
                  value={this.state.problem}
                  loading={this.state.isLoadingProblem}
                  showClear={true}
                  placeholder='Select an item to repair first'
                  style={{ width: '100%' }} />
              </div>
            </div>
             {/* Appointment */}
             <div className='col-sm-3'  style={{paddingLeft: 0}}>
              <label className='col-sm-12 control-label form-siteone-label'>
               Appointment
              </label>              
              <div className='col-sm-12 control-label name form-text-label ' style={{paddingLeft: 15}}>
                <Datetime
                  ref={ref => { this.appointmentDate = ref; }}
                  name='appointmentDate'
                  initialViewDate={this.state.appointmentDate?Moment(this.state.appointmentDate)
                    :Moment(new Date()).set({ hour: 9, minute: 0 })}
                  inputProps={{ placeholder: 'mm/dd/yyyy hh:mm', disabled: isEditAppointment }}
                  value={this.state.appointmentDate}
                  onChange={this.onChangeAppointmentDate} 
                  closeOnSelect={true}
                  isValidDate={isValidAppointmentDate}
                  disabled={isEditAppointment}
                />
                {this.state.error &&
                  <span className='text-danger' style={{fontSize: 12}}>{this.state.error}</span>
                }
              </div>
            </div>  
          </div>
          <div className='row col-lg-12 col-sm-12'>
            {/* Summary */}
            <div className=' col-sm-3' style={{paddingLeft: 0, marginRight: '15rem'}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Summary
              </label>              
                <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Input
                  type='text'
                  name='title'
                  ref='title'
                  className='form-control'
                  onChangeCallback={(value) => { this.setState({ title: value }); }}
                  value={this.state.title}
                  max='200'
                  maxLength='200'
                   />
                </div>
            </div>  
              {/* Description */}
            <div className=" col-sm-3" style={{paddingLeft: 0, marginRight: '15rem'}}>
              <label className="col-sm-12 control-label form-siteone-label">
                Description
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Textarea
                  className="form-control"
                  name="description"
                  ref="description"
                  max="1000"
                  maxLength="1000"
                  errorMsg="Description is maximum 1000 characters"
                  rows='3'
                  style={{ width: '100%' }}
                  value={this.state.description}
                  onChangeCallback={(value) => { this.setState({ description: value }); }}
                />
              </div>
            </div>
            {/* Attachment */}
             <div className=" col-sm-3" style={{paddingLeft: 0}}>
              <label className='col-sm-12 control-label form-siteone-label'>
                Attachments
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropzone
                disableClick
                style={{ position: "initial" }}
                ref={(ref) => {
                  this.dropzoneRef = ref;
                }}
                onDrop={this.onDropOnAttachments}
              >
                <span
                  className="add-new-attachment-label"
                  onClick={(e) => this.dropzoneRef.open()}
                >
                  + Add new attachment
                </span>
              </Dropzone>
              {this.state.errorFile && (
                <div
                  className="text-danger"
                  style={{ marginLeft: 15, fontSize: 12 }}
                >
                  {this.state.errorFile}
                </div>
              )}

              {this.state.files.map((f) => (
                <div key={f.name} style={{ marginBottom: 2 }}>
                  <div style={{
                    width: 50,
                    height: 60,
                    // marginLeft: 15,
                    marginRight: 10,
                    borderRadius: 2,
                    verticalAlign: 'top',
                    backgroundImage: `url(${this.renderFileTypeIcon(f)})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'inline-block'
                  }} />
                  <span style={{ fontStyle: "italic" }}>{f.name}</span>
                  {/* <i
                    className="fa fa-trash"
                    style={{ cursor: "pointer", marginLeft: 10}}
                    onClick={() => this.onClickTrashIcon(f)}
                  /> */}
                </div>
              ))}            
              </div> 
            </div>
          </div>
          <ul className='wo-detail-bottom-btn'>
            <li className='wo-edit-li'>
              <span
                className='btn btn-primary btn-siteone-default btn-wo-edit punch-item-cancel-btn'
                onClick={()=>{this.onhandleClose(SelectedWO.refNo)}}
                >
                Cancel
              </span>
            </li>
            <li>
            {this.state.isDisplayPopoverReassign &&
                <Popup ref={(ref) => { this.reassignPopup = ref; }} isHasFaded={true} styles={{
                  width: 500,
                  top: -200,
                  left: 160,
                  padding: 20,
                  paddingTop: 30,
                  borderRadius: 2
                }}>
                  <div>
                    <span>You have just specified another assignee.</span><br/>
                    <span>Saving this change will also send this work order to the new assignee <br/>and reset the due date.</span>
                    <div style={{marginTop: 20}}>
                      <button
                        className='btn btn-primary btn-siteone-default'
                        onClick={() => this.setState({isDisplayPopoverReassign: false})}>Cancel</button>
                      <button
                        className='btn btn-primary btn-submit btn-siteone'
                        onClick={this.onSave}>Save & Send</button>
                    </div>
                  </div>
                </Popup>
              }
              <Submit
                className='btn btn-primary btn-submit btn-siteone'
                disabled={isDisabled}>
                Update
              </Submit>
            </li>
          </ul>
          </Form>  
          {/* <li className='wo-detail-bottom-btn' >
            <button
              className='btn btn-primary btn-siteone btn-siteone-orange'
              disabled={isUpdateSend}
              onClick={this.onUpdateandSend}>
              Update & Send
            </button>
          </li> */}
          {this.state.conditionRenderBottomBtn ? null : this.props.WorkOrderProfile !== null ? this.renderButtonGroup(this.props.WorkOrderProfile): ''}
          {this.state.displayModal === true ?  <Modal show={true} className='singleWOUpdate' onHide={this.handleModalClose}
              style={{marginTop: '8%'}}>            
              <Modal.Header>
                <Modal.Title>{this.state.heading}</Modal.Title>
                <button className='close'>
                  <i className='icon-icn_close' />
                </button>
              </Modal.Header>
            <Modal.Body>
              <div>{this.state.modalContent}</div>
            </Modal.Body>
            <Modal.Footer>
              <div style={{float: 'left'}}>
              <button
                className='btn btn-primary btn-siteone'
                onClick={()=>{this.handleModalClose(SelectedWO.refNo)}}
                >
                OK
              </button>               
              </div>
            </Modal.Footer>
          </Modal> : ''}       
      </div>
    );
  }
  }

  onPageChange(page, sizePerPage) {
    const params = {
      defaultSortName: this.state.defaultSortName,
      defaultSortOrder: this.state.defaultSortOrder,
      currentPage: page,
      sizePerPage: sizePerPage
    };

    this.setState(
      {
        defaultSortName: this.state.defaultSortName,
        defaultSortOrder: this.state.defaultSortOrder,
        currentPage: page,
        sizePerPage: sizePerPage
      },
      () => {
        if (this.props.refreshList) {
          this.props.refreshList(params);
        }
      }
    );
  }

  sizePerPageListChange(sizePerPage) {
    const { options } = this.props;
    const params = {
      defaultSortName: options.defaultSortName,
      defaultSortOrder: options.defaultSortOrder,
      currentPage: 1,
      sizePerPage: sizePerPage
    };

    this.setState(
      {
        currentPage: 1,
        sizePerPage: sizePerPage,
        defaultSortName: options.defaultSortName,
        defaultSortOrder: options.defaultSortOrder
      },
      () => {
        if (this.props.refreshPageList) {
          this.props.refreshPageList(params);
        }
      }
    );
  }

  customColumnWidth = (widthStyle, width) => {
    if (widthStyle) {
      switch (widthStyle) {
        case 'projectName':
          return '400px';
        case 'name':
          return '150px';
        case 'address':
          return '400px';
        case 'description-punchlist':
          return '350px';
        case 'number':
          return '80px';
        case 'legacy':
          return '120px';
        case 'legacyWO':
          return '125px';
        case 'appointment':
          return '200px';
        default:
          return null;
      }
    }

    if (width) {
      return width;
    }

    return null;
  };

  renderCell = cell => {
    return <span>{cell}</span>;
  };

  renderPaginationPanel(props) {
    return (
      <div className='fs-paging clearfix'>
        {!this.props.options.hideSizePerPage ? (
          <div className='col-md-4 col-sm-5 col-lg-3'>
            <div className='change-page-size pull-left'>
              <span className='info-per-page'>Show </span>
              <span className='item-per-page'>
                {props.components.sizePerPageDropdown}
              </span>
              <span className='info-per-page'> items / page </span>
            </div>
          </div>
        ) : (
          <div className='col-md-4 col-sm-5 col-lg-3' />
        )}

        <div className='col-md-8 col-sm-7 col-lg-9'>
          <div className='page-list pull-right'>
            {props.components.pageList}
          </div>
        </div>
      </div>
    );
  }

  renderColumn() {
    const { column } = this.props;
    let col;
    col = column.map((t, i) => {
      if (t.customRender) {
        return (
          <TableHeaderColumn
            key={i}
            dataAlign={t.dataAlign}
            headerAlign={t.headerAlign}
            dataField={t.field}
            className={t.className}
            columnClassName={t.columnClassName}
            width={this.customColumnWidth(t.widthStyle, t.width)}
            isKey={t.isKey ? true : false}
            dataSort={t.sort ? true : false}
            hidden={t.hidden ? true : false}
            caretRender={this.props.caretRender}
            dataFormat={(cell, row) =>
              t.field === '' || (t.field && cell !== '' && cell !== null)
                ? this.renderCell(t.customRender(row))
                : '-'
            }
          >
            {t.header}
          </TableHeaderColumn>
        );
      }

      return (
        <TableHeaderColumn
          key={i}
          dataField={t.field}
          // dataAlign={t.headerAlign}
          dataAlign={t.dataAlign}
          headerAlign={t.headerAlign}
          className={t.className}
          columnClassName={t.columnClassName}
          width={this.customColumnWidth(t.widthStyle, t.width)}
          isKey={t.isKey ? true : false}
          dataSort={t.sort ? true : false}
          hidden={t.hidden ? true : false}
          caretRender={this.props.caretRender}
          dataFormat={cell =>
            cell !== '' && cell !== null ? this.renderCell(cell) : '-'
          }
        >
          {t.header}
        </TableHeaderColumn>
      );
    });

    return col;
  }
 
  renderTableBody = data => {
    if (this.props.isDisplayTable) {

      if(this.props.openAccordion == true && AppSettings.clientTypeValue !== "Subcontractor" && AppSettings.clientTypeValue !== 'Homeowner'){
        const onRowSelect = ({ refNo }, isSelected) => {
          const checkID = this.state.selected.indexOf(refNo)
          if (checkID == -1) {
            this.fetchDetailWorkOrder(refNo);
            this.setState({
              selected: [ refNo ],
              SelectedWO: this.state.data.find((item)=> item.refNo == refNo),
              trade: null,
              itemToRepair: null,
              subcontractor: null,
              workOrderType: null,
              problem: null,
              user: null,
              files: [],
              errorFile: null,
              appointmentDate: null,
              description: null,
              title: null,
            }); 
            originalState = null;
            isDisabled = true;
            isUpdateSend = true;
          } else {
            this.setState({ selected: this.state.selected.filter(it => it !== refNo) });
          }
          return false;  //important          
        }
          const selectRowProp = {
            mode: 'radio',
            hideSelectColumn: true,
            clickToSelect: true,
            clickToExpand: true,   // you should add this to trigger selection and expand both on clicking
            bgColor: '#F5F5F5',
            selected: this.state.selected,
            onSelect: onRowSelect ,
            onlyOneExpanding: true
          };

        return (                    
          <FSTable
            {...this.props}
            ignoreSinglePage={this.props.ignoreSinglePage}
            data={data}
            pagination={this.props.pagination}
            remote={true}
            fetchInfo={{ dataTotalSize: this.state.totalRecord }}
            options={{
              sortIndicator: false,
              defaultSortName: this.state.defaultSortName,
              defaultSortOrder:
                this.state.defaultSortOrder === 'ascending' ? 'asc' : 'desc',
              sizePerPage: this.props.ignoreSinglePage
                ? 9999
                : this.state.sizePerPage,
              sizePerPageList: [10, 20, 30, 40, 50, 100],
              page: this.state.currentPage,
              onPageChange: this.onPageChange.bind(this),
              onSortChange: this.onSortChange.bind(this),
              paginationPanel: this.renderPaginationPanel.bind(this),
              onSizePerPageList: this.sizePerPageListChange.bind(this),
            }}
            hover={true}
            bordered={false}
            tableBodyClass='table fs-table body-table'
            tableHeaderClass='table table fs-table header-table'
            trClassName={this.props.trClassName}
            tableStyle={
              !this.props.pagination
                ? { borderBottom: '1px solid #E7E7E9', marginBottom: 20 }
                : null
            }
            selectRow={selectRowProp}
            expandableRow={this.isExpandableRow}
            expandComponent={ this.expandComponent }
            expandColumnOptions={ { 
              expandColumnVisible: true,
              expandColumnComponent: this.expandColumnComponent,
              columnWidth: 50
            } }
            onlyOneExpanding={true}
            expanding={this.state.selected}
          >
            {this.renderColumn(this)}
          </FSTable>
        );
      }else {
      return (                    
        <FSTable
          {...this.props}
          ignoreSinglePage={this.props.ignoreSinglePage}
          data={data}
          pagination={this.props.pagination}
          remote={true}
          fetchInfo={{ dataTotalSize: this.state.totalRecord }}
          options={{
            sortIndicator: false,
            defaultSortName: this.state.defaultSortName,
            defaultSortOrder:
              this.state.defaultSortOrder === 'ascending' ? 'asc' : 'desc',
            sizePerPage: this.props.ignoreSinglePage
              ? 9999
              : this.state.sizePerPage,
            sizePerPageList: [10, 20, 30, 40, 50, 100],
            page: this.state.currentPage,
            onPageChange: this.onPageChange.bind(this),
            onSortChange: this.onSortChange.bind(this),
            paginationPanel: this.renderPaginationPanel.bind(this),
            onSizePerPageList: this.sizePerPageListChange.bind(this),
          }}
          hover={true}
          bordered={false}
          tableBodyClass='table fs-table body-table'
          tableHeaderClass='table table fs-table header-table'
          trClassName={this.props.trClassName}
          tableStyle={
            !this.props.pagination
              ? { borderBottom: '1px solid #E7E7E9', marginBottom: 20 }
              : null
          }
        >
          {this.renderColumn(this)}
        </FSTable>
      );
    }
    }

    if (this.props.applySkeleton) {
      return <Skeleton count={13} style={{ height: 15, margin: '12px 0' }} />;
    }

    return null;
  };

  render() {
    const { data } = this.state;

    return (
      <div className={this.props.reassignCSS == true ? 'box-fs-table-reassign' : 'box-fs-table'}>
        {this.props.customTableHeader || null}
        {this.renderTableBody(data)}
      </div>
    );
  }
}

TableList.propTypes = {
  column: PropTypes.array,
  refreshPageList: PropTypes.func,
  refreshList: PropTypes.func,
  data: PropTypes.array,
  options: PropTypes.object,
  defaultParams: PropTypes.object,
  customTableHeader: PropTypes.any,
  trClassName: PropTypes.any,
  ignoreSinglePage: PropTypes.bool,
  pagination: PropTypes.bool,
  caretRender: PropTypes.any,
  isDisplayTable: PropTypes.bool,
  applySkeleton: PropTypes.bool,
  containerStyle:PropTypes.object
};

TableList.defaultProps = {
  pagination: true,
  caretRender: null,
  isDisplayTable: true,
  applySkeleton: false
};

const mapStateToProps = (state) => {
  if(AppSettings.clientTypeValue === 'System'){
    return null
  }else{
    return {
      WorkOrderProfile: state.WorkOrderReducer.WorkOrderProfile,
      WorkOrderTypeList: state.WorkOrderTypesStore.WOTList,
      TradeList: state.LotStore.TradeList,
      ItemToRepairList: state.TradeStore.ItemRepairList,
      ProblemList: state.ItemRepairStore.ProblemList,
      LotList: state.ProjectStore.LotList,
      SubcontractorList: state.SubcontractorStore.SubcontractorList,
      UserList: state.ProjectStore.UserSelectList,
      UserProfile: state.UserStore.UserProfile,
      ManagerStore: state.RFSStore,
      LotStore: state.LotStore,
      UploadSuccess: state.WorkOrderReducer.UploadSuccess,
      checkHomeownerWO: state.WorkOrderReducer.checkHomeownerWO,
      WorkOrderCredentials: state.WorkOrderReducer.Credentials,
      LastResolvedByDetails: state.WorkOrderReducer.LastResolvedByDetails

    };
  }
};

export default connect(mapStateToProps)(TableList);

















{/* Comments */}
            {/* <div className=' col-sm-3' style={{paddingLeft: 0, marginRight: '15rem'}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Comments: 
              </label>              
                <div className='col-sm-12' style={{paddingLeft: 15}}>
                  <Textarea
                    name='comment_note'
                    ref='comment_note'
                    className='form-control'
                    maxLength='1000'
                    value={this.state.comment_note}
                    onChange={this.handleChange}
                    rows='2'
                    placeholder="Add a note"
                  />
                </div>
            </div>   */}
          {/* private notes */}
            {/* <div className='col-sm-3'  style={{paddingLeft: 0, marginRight: '15rem'}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Private Notes: 
              </label>              
                <div className='col-sm-12' style={{paddingLeft: 15}}>
                  <Textarea
                    name='description_note'
                    ref='description_note'
                    className='form-control'
                    maxLength='1000'
                    value={this.state.description_note}
                    onChange={this.handleChange}
                    rows='2'
                    placeholder="Add a note, this note won't be visible to the homeowners."
                  />
                </div>
            </div>   */}


// WEBPACK FOOTER //
// ./src/components/TableList/index.js